import React from 'react'
import classnames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  EmailShareButton,
} from 'react-share'

import {
  FacebookShareCount,
  GooglePlusShareCount,
  LinkedinShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
  TumblrShareCount,
} from 'react-share'

import {
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon,
  GooglePlusIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  RedditIcon,
  TumblrIcon,
  LivejournalIcon,
  MailruIcon,
  EmailIcon,
} from 'react-share'

class Share extends React.Component {
  render() {
    const { classes, shareUrl, title, orientation = 'vertical' } = this.props

    return (
      <div className={classes.shareButtons}>
        <div
          className={classnames(
            classes.shareButton,
            orientation === 'horizontal' && classes.shareHorizontal
          )}
          role="button"
          style={{ cursor: 'pointer', outline: 'none !important' }}
        >
          <FacebookShareButton url={shareUrl} quote={title.text} className={classes.shareButtonNone}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div
          className={classnames(
            classes.shareButton,
            orientation === 'horizontal' && classes.shareHorizontal
          )}
          role="button"
          style={{ cursor: 'pointer', outline: 'none !important' }}
        >
          <TwitterShareButton url={shareUrl} quote={title.text} className={classes.shareButtonNone}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div
          className={classnames(
            classes.shareButton,
            orientation === 'horizontal' && classes.shareHorizontal
          )}
          role="button"
          style={{ cursor: 'pointer', outline: 'none !important' }}
        >
          <LinkedinShareButton url={shareUrl} quote={title.text} className={classes.shareButtonNone}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
      </div>
    )
  }
}
export default withStyles(styles)(Share)



// WEBPACK FOOTER //
// ./src/components/share/index.js